import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ToppyComponent } from './toppy.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ToppyComponent],
  entryComponents: [ToppyComponent]
})
export class ToppyModule {}
